import { render, staticRenderFns } from "./AccountStep.vue?vue&type=template&id=51cc8876&"
import script from "./AccountStep.vue?vue&type=script&lang=js&"
export * from "./AccountStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports